import React from 'react';
import ReactDOM from 'react-dom';
import './CustomNotification.less';
import { CloseButton } from '../CustomIcons/CloseButton/web';
import { CheckIcon } from '../CustomIcons/CheckIcon/web';

async function showNotification(type = 'success', tittle = '', description = '', time = 8000) {

    const notification = (
        <div className="custom-notification">

            <div className={`type type-${type}`}>
                {type == 'success' ? <CheckIcon></CheckIcon> : <CloseButton></CloseButton>}
            </div>
            <button className="close-button" onClick={() => hideNotification()}>
                <CloseButton></CloseButton>
            </button>
            <div className="notification-content">
                <b className="title">{tittle}</b>
                <div>{description}</div>
            </div>
        </div >
    );

    setTime(time)

    const notificationContainer = document.createElement('div');
    notificationContainer.className = 'notification-container';
    document.body.appendChild(notificationContainer);

    ReactDOM.render(notification, notificationContainer);
}

const setTime = (time) => {
    setTimeout(() => {
        hideNotification();
    }, time);

}

const hideNotification = () => {
    const existingContainer = document.querySelector('.notification-container');
    if (existingContainer) {
        ReactDOM.unmountComponentAtNode(existingContainer);
        existingContainer.parentNode.removeChild(existingContainer);
    }
}

export { showNotification, hideNotification };
